import { ReactComponent as GraphIcon } from './graph.svg';

export default GraphIcon;
